// extracted by mini-css-extract-plugin
export var verifiedLabel = "VerifiedPill-module--verifiedLabel--aa82e";